import { render, staticRenderFns } from "./ReportVictimDetail.vue?vue&type=template&id=703150bf&scoped=true"
import script from "./ReportVictimDetail.vue?vue&type=script&lang=js"
export * from "./ReportVictimDetail.vue?vue&type=script&lang=js"
import style0 from "./ReportVictimDetail.vue?vue&type=style&index=0&id=703150bf&prod&scoped=true&lang=css"
import style1 from "./ReportVictimDetail.vue?vue&type=style&index=1&id=703150bf&prod&lang=css"
import style2 from "./ReportVictimDetail.vue?vue&type=style&index=2&id=703150bf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703150bf",
  null
  
)

export default component.exports